import { OrthodonticsForTeensPage } from "~/components/orthodontics-for-teens/OrthodonticsForTeensPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/orthodontics-for-teens")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo(
      "/orthodontics-for-teens",
    ),
  component: OrthodonticsForTeensPage,
});
